   <!-- Header HTML Start -->
   <app-header></app-header>
   <!-- Header HTML End -->
 
    <router-outlet></router-outlet>

  <!-- Footer HTML Start -->
  <app-footer></app-footer>
  <!-- Footer HTML End -->

